module.exports = __webpack_public_path__ + "img/clock-nine-thirty.e427f6b9.svg";